import service from 'modules/service';
import { intl } from 'modules/i18n';
import { getUserProfile } from 'modules/auth/selectors';
import { loadUserProfile } from 'modules/auth/actions';
import { EVENT_CATEGORY } from 'modules/common/constants';
import { confirm, getErrorText, showErrorSnackbar } from 'modules/common/utils';
import * as storeActions from './storeActions';

export const addOwnerRole = (memberId, ownerId, role) => async (dispatch, getState) => {
    const confirmation = await confirm({
        title: intl.formatMessage({ id: 'admin.addRole' }),
        messages: [ intl.formatMessage({ id: 'admin.addRoleConfirmationMessage' }) ],
        confirmButtonText: intl.formatMessage({ id: 'common.confirm' }),
        cancelButtonText: intl.formatMessage({ id: 'common.cancel' }),
        cancelButtonClass: 'btn-flat'
    });

    if (confirmation) {
        dispatch(storeActions.setOwnerMembershipsListOperationInProgress(true));

        try {
            await service.api.addOwnerRole(memberId, ownerId, role);

            dispatch(storeActions.addOwnerMemberRole({ memberId, role }));

            service.analytics.trackEvent('Add owner member role', EVENT_CATEGORY.ADMIN, role);

            const { id } = getUserProfile(getState());
            if (id === memberId) {
                await dispatch(loadUserProfile());
            }
        } catch (err) {
            showErrorSnackbar(getErrorText(err));
        } finally {
            dispatch(storeActions.setOwnerMembershipsListOperationInProgress(false));
        }
    }
};

export const deleteOwnerMembership = (memberId, ownerId) => async (dispatch, getState) => {
    const confirmation = await confirm({
        title: intl.formatMessage({ id: 'admin.revokeMembership' }),
        messages: [ intl.formatMessage({ id: 'admin.ownerRevokeMembershipConfirmationMessage' }) ],
        confirmButtonText: intl.formatMessage({ id: 'common.confirm' }),
        confirmButtonClass: 'btn-negative',
        cancelButtonText: intl.formatMessage({ id: 'common.cancel' }),
        cancelButtonClass: 'btn-flat'
    });

    if (confirmation) {
        dispatch(storeActions.setOwnerMembershipsListOperationInProgress(true));

        try {
            await service.api.deleteOwnerMembership(memberId, ownerId);

            dispatch(storeActions.removeOwnerMembership({ memberId, ownerId }));

            service.analytics.trackEvent('Revoke owner membership', EVENT_CATEGORY.ADMIN);

            const { id } = getUserProfile(getState());
            if (id === memberId) {
                await dispatch(loadUserProfile());
            }
        } catch (err) {
            showErrorSnackbar(getErrorText(err));
        } finally {
            dispatch(storeActions.setOwnerMembershipsListOperationInProgress(false));
        }
    }
};

export const deleteOwnerRole = (memberId, ownerId, role) => async (dispatch, getState) => {
    const confirmation = await confirm({
        title: intl.formatMessage({ id: 'admin.removeRole' }),
        messages: [ intl.formatMessage({ id: 'admin.removeRoleConfirmationMessage' }) ],
        confirmButtonText: intl.formatMessage({ id: 'common.confirm' }),
        confirmButtonClass: 'btn-negative',
        cancelButtonText: intl.formatMessage({ id: 'common.cancel' }),
        cancelButtonClass: 'btn-flat'
    });

    if (confirmation) {
        dispatch(storeActions.setOwnerMembershipsListOperationInProgress(true));

        try {
            await service.api.deleteOwnerRole(memberId, ownerId, role);

            dispatch(storeActions.removeOwnerMemberRole({ memberId, role }));

            service.analytics.trackEvent('Remove owner member role', EVENT_CATEGORY.ADMIN);

            const { id } = getUserProfile(getState());
            if (id === memberId) {
                await dispatch(loadUserProfile());
            }
        } catch (err) {
            showErrorSnackbar(getErrorText(err));
        } finally {
            dispatch(storeActions.setOwnerMembershipsListOperationInProgress(false));
        }
    }
};
